module.exports = __webpack_public_path__ + "img/6.aa1ba64b.png";